<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert" />
      SKU单品进销存报告—构建前需要先
      <router-link to="/report/data" slot="extra">(同步统计数据)</router-link>
    </p>
    <template slot="extra"> </template>
    <Row>
      <Col span="24">
        <Input
          v-model="query.spCode"
          placeholder="资金商code"
          class="public-inp md5"
        />
        <Input
          v-model="query.sku"
          placeholder="sku code"
          class="public-inp md5"
        /><br />
        <Select
          v-model="query.year"
          placeholder="请选择统计年份"
          class="public-inp md5"
        >
          <Option v-for="item in yearList" :value="item" :key="item"
            >{{ item }}
          </Option>
        </Select>
        <Select
          v-model="query.month"
          placeholder="请选择统计月份"
          class="public-inp md5"
        >
          <Option v-for="item in monthList" :value="item" :key="item"
            >{{ item }}
          </Option>
        </Select>
        <Button
          type="primary"
          icon="md-refresh"
          class="public-fr"
          @click="buildReport()"
          :disabled="isDisabled"
          v-access="'report.spData.add'"
          >构建统计报表
        </Button>
        <Button
          type="primary"
          icon="md-add"
          class="public-fr"
          @click="sllInImport()"
          v-access="'report.spData.add'"
          >初始化SellIn信息</Button
        >
        <Button
          type="primary"
          icon="md-add"
          class="public-fr"
          @click="stockImport()"
          v-access="'report.spData.add'"
          >初始化期初|期末库存</Button
        >
        <Button
          class="public-fr"
          @click="reset()"
          v-access="'report.spData.reset'"
          >重置</Button
        >
        <Button
          class="public-fr"
          type="primary"
          icon="ios-search"
          @click="getList()"
          v-access="'report.spData.query'"
          >查询</Button
        >
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ row, index }" slot="sort">
            <span v-show="false">{{ row.code }}</span>
            {{ index + 1 }}
          </template>
          <template slot-scope="{ row, index }" slot="action">
            <a href="javascript:;" @click="editFn(row)">编辑</a>
          </template>
          <template slot-scope="{ row }" slot="status">
            <i-switch
              :value="row.status == 1"
              :before-change="beforeStateChange"
              @on-change="stateChange(row, $event)"
            />
          </template>
        </Table>
        <Page
          :style="{ float: 'right', marginTop: '10px' }"
          :total="total"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          show-elevator
          @on-change="pageNumChange"
          @on-page-size-change="pageSizeChange"
        />
      </Col>
    </Row>
  </Card>
</template>
<script>
import columns from "@/views/task/columns";

export default {
  data() {
    return {
      visiable: false,
      open: false,
      query: {
        page: 1,
        rows: 10,
        sku: "",
        spCode: "",
        year: "",
        month: "",
      },
      columns: [
        {
          title: "id",
          key: "id",
          width: 70,
          fixed: "left",
        },
        {
          title: "年/月",
          key: "year",
          width: 85,
          render: (h, params) => {
            let name = params.row.year + "/" + params.row.month;
            return h("div", name);
          },
        },
        {
          title: "资金商code",
          key: "spCode",
          width: 110,
        },
        {
          title: "资金商名称",
          key: "name",
          width: 160,
        },
        {
          title: "sku编码",
          key: "sku",
          width: 90,
        },
        {
          title: "sku名称",
          key: "skuName",
          width: 90,
        },
        {
          title: "期初库存",
          key: "openingStock",
          width: 100,
        },
        {
          title: "sellIn",
          key: "dmsSellin",
          width: 80,
        },
        {
          title: "sellOut",
          key: "dmsSellout",
          width: 80,
        },
        {
          title: "其他库存",
          key: "dmsOther",
          width: 85,
        },
        {
          title: "期末库存",
          key: "endingStock",
          width: 100,
        },
        {
          title: "理论库存",
          key: "stock",
          width: 85,
        },
        {
          title: "GAP(实盘-理论)",
          key: "gap",
          width: 130,
        },
        {
          title: "创建时间",
          key: "createtime",
          width: 150,
        },
        {
          title: "更新时间",
          key: "updatetime",
          width: 150,
          fixed: "right",
        },
      ],
      tbList: [],
      loading: false,
      total: 0,
      yearList: [2020, 2021, 2022, 2023, 2024, 2025, 2026],
      monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let data = this.query;
      this.loading = true;
      this.$api.getSkuReportSpList(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
          this.total = res.total;
        }
      });
    },
    reset() {
      this.query.spCode = "";
      this.query.sku = "";
      this.query.year = "";
      this.query.month = "";
      this.$nextTick(() => {
        this.getList();
      });
    },
    uploadToggle() {
      this.visiable = !this.visiable;
    },
    // 页码
    pageNumChange(pageNum) {
      this.query.page = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.query.rows = pageSize;
      // 页码变动触发pageNumChange
      if (this.query.page == 1) {
        this.getList();
      } else {
        this.query.page = 1;
      }
    },
    buildReport() {
      this.$router.push({
        name: "build",
      });
    },
    sllInImport() {
      this.$router.push({
        name: "sllIn",
      });
    },
    stockImport() {
      this.$router.push({
        name: "spStock",
      });
    },
    beforeStateChange() {
      return new Promise((resolve, reject) => {
        this.$Modal.confirm({
          title: "切换确认",
          content: "您确认要切换状态吗？",
          onOk: resolve,
          oncancel: reject,
        });
      });
    },
    stateChange(d, v) {
      if (v) {
        this.$api.enableSkuReportSpMeta({ id: d.id }).then((res) => {
          if (res.code == "200") {
            this.$Message.success("启用成功");
            this.getList();
          } else {
            this.$Message.error("启用失败");
          }
        });
      } else {
        this.$api.disableSkuReportSpMeta({ id: d.id }).then((res) => {
          if (res.code == "200") {
            this.$Message.success("禁用成功");
            this.getList();
          } else {
            this.$Message.error("禁用失败");
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.md5 {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/report/spData.vue